import { render, staticRenderFns } from "./LegislationChart.vue?vue&type=template&id=9aebb520&scoped=true"
import script from "./LegislationChart.vue?vue&type=script&lang=js"
export * from "./LegislationChart.vue?vue&type=script&lang=js"
import style0 from "./LegislationChart.vue?vue&type=style&index=0&id=9aebb520&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aebb520",
  null
  
)

export default component.exports